import { Button } from 'components/Button';
import { Heading, Paragraph } from 'components/Typography';
import config from 'config';
import { ExpressablesFooter } from 'components/Layout/AuthenticationLayout';
import { withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { useTranslation } from 'react-i18next';

const supportEmail = config.get('supportEmail');

const ContactSupport: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col items-center m-auto text-center">
        <Heading level="h2" as="h1" className="whitespace-pre-wrap">
          {t(`schedule.confirm.error.title`)}
        </Heading>
        <Paragraph className="mt-12">{t(`schedule.confirm.error.description`)}</Paragraph>

        <Button as="a" href={`mailto:${supportEmail}`} className="mt-32" size="lg">
          {t(`schedule.confirm.error.confirmButton`)}
        </Button>
      </div>

      <ExpressablesFooter style={{ position: 'absolute', left: 0, bottom: 0 }} />
    </>
  );
};

export const ScheduleV3ContactSupport = withScheduleMachineStateV3(ContactSupport, 'contactSupport');
